import { useQuery } from "@tanstack/react-query";

import { queries } from "./factories";

export const useStatesListQuery = ({
  isEligible,
  enabled = true,
}: { isEligible?: boolean; enabled?: boolean } = {}) => {
  return useQuery({ ...queries.list(isEligible), enabled });
};
